import React from 'react';

import {handleNewLabel} from '/component/base/NewLabelCandidate/NewLabelCandidate.util';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './NewLabelCandidate.style';

interface Item {
  isFrontLine: boolean;
  isNew: boolean;
}

interface NewLabelCandidateProps {
  item: Item | null;
}

export const NewLabelCandidate: React.FC<NewLabelCandidateProps> = ({
  item = null,
}) => {
  const {tt} = useTranslation('report.record.newLabel');
  const showNewLabel = handleNewLabel({item});
  return showNewLabel ? (
    <Text
      variant="caption"
      style={styles.newLabel}
      {...testProperties(Reports.reportNewTag)}>
      {tt('newLabel', 'New')}
    </Text>
  ) : null;
};
